import React from "react";
import { Container, Row, Col, Spinner, Placeholder } from "react-bootstrap";
import LeaderBoardTable from "../../League/Components/LeaderBoardTable";
import { Leaderboard } from "../../../types/model";
import SmallLogo from "../../common/SmallLogo";

interface HomepageLeaderBoardProps {
	leaderboard: Leaderboard;
	leaderBoardLoading: boolean;
}

const HomepageLeaderBoard: React.FC<HomepageLeaderBoardProps> = ({
	leaderboard,
	leaderBoardLoading,
}) => {
	return (
		<Row>
			<Col>
				{leaderBoardLoading ? (
					<Placeholder as="div" animation="glow" className="my-3">
						<Placeholder
							xs={11}
							className="rounded-3"
							bg="light"
							style={{ height: "15rem" }}
						/>
					</Placeholder>
				) : (
					<LeaderBoardTable
						leaderboard={leaderboard}
						showPointsBreakdown={false}
						showLeagueName={false}
						expanded={false}
					/>
				)}
			</Col>
		</Row>
	);
};

export default HomepageLeaderBoard;
